import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { screenHeightLeftFromTop } from "Constants";
import LocaleStrings from "Languages";
import SponsorInsightMenuIcon from "./sponsorinsight-menu-icon";
import TableContentTopSponsor from "./table-content-top-sponsor";
import TableContentMostsearchSponsorinsight from "./table-content-mostsearch-sponsorinsight";
import SponsorsinsightEngmntBarChart from "./sponsorsinsight-engmnt-barchart";
//import AnalyticsCommonHeader from "../../common/analytics-common-header";
import AnalyticsCommonHeader from "AnalyticscommonAnalyticscommon";

import {
  fetchSponsorsinsightMostsearkeysTableData,
  fetchTopSponsorTableData,
  fetchsponengagementbBarChart,
} from "SponsorinsightActions";
import { sponsorsinsightnoofsponcount } from "SponsorinsightNoofsponAction";
import { sponsorsinsightsponlistviewcount } from "SponsorinsightSponlistviewAction";
import { sponsorsinsightsponprofviewcount } from "SponsorinsightSponprofviewAction";
import { sponsorsinsightsearchcount } from "SponsorinsightSponsearchAction";
import { sponsorsinsightsponfavocount } from "SponsorinsightSponfavoAction";

var Loader = require("react-loaders").Loader; // import "AwesomeLoaderCss";

class Sponsorsinsight extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      desc: LocaleStrings.analytics_text_preparing_analytics,
      loader: false,
    };
  }

  //
  componentDidMount() {
    this.props.sponsorsinsightnoofsponcount(
      this.props.session,
      (sponsorsinsightnoofsponresponse) => {
        if (sponsorsinsightnoofsponresponse.error === 0) {
        }
      }
    );

    this.props.sponsorsinsightsponlistviewcount(
      this.props.session,
      (sponsorsinsightsponlistviewresponse) => {
        if (sponsorsinsightsponlistviewresponse.error === 0) {
        }
      }
    );

    this.props.sponsorsinsightsponprofviewcount(
      this.props.session,
      (sponsorsinsightsponprofviewresponse) => {
        if (sponsorsinsightsponprofviewresponse.error === 0) {
          //
        }
      }
    );

    // Call to Number of searches done on Sponsor list [Sponsor searches]
    this.props.sponsorsinsightsearchcount(
      this.props.session,
      (sponsorsinsightsearchcountResponse) => {
        if (sponsorsinsightsearchcountResponse.error === 0) {
          //
        }
      }
    );

    this.props.sponsorsinsightsponfavocount(
      this.props.session,
      (sponsorsinsightsponfavoresponse) => {
        if (sponsorsinsightsponfavoresponse.error === 0) {
          //
        }
      }
    );

    this.props.fetchSponsorsinsightMostsearkeysTableData(
      this.props.session,
      (sponsorsinsightmostsearkeysResponse) => {
        if (sponsorsinsightmostsearkeysResponse.error === 0) {
          //
        }
      }
    );

    // Top sponsors (sponsors profiles with most user engagement)
    this.props.fetchTopSponsorTableData(
      this.props.session,
      (fetchtopsponsortabledataResponse) => {
        if (fetchtopsponsortabledataResponse.error === 0) {
        }
      }
    );

    // Top sponsors ( engagement bar chart)
    this.props.fetchsponengagementbBarChart(
      this.props.session,
      this.props.datePropsMainPg,
      (fetchsponengagementbbarchartResponse) => {
        if (fetchsponengagementbbarchartResponse.error === 0) {
          this.setState({ loading: false });
        }
      }
    );
  }

  //Arrow function for renderLoader
  renderLoader = () => {
    return (
      <Loader type="line-scale-pulse-out-rapid" active className="loader-div" />
    );
  };

  // Arrow function for render Sponsors Insights menu divs
  renderSponsorinsightMenuIcons() {
    return _.map(this.props.sponsorInsightMenu, (sponsorinsightmenuItem) => {
      return (
        <SponsorInsightMenuIcon
          menu={sponsorinsightmenuItem}
          key={sponsorinsightmenuItem.key}
        />
      );
    });
  }

  newfc(obj) {
    this.setState({ loader: !this.state.loader });
  }

  // Rerender All componets on this page
  mainCallback = () => {
    this.setState({ loading: true });

    this.props.sponsorsinsightnoofsponcount(
      this.props.session,
      (sponsorsinsightnoofsponresponse) => {
        if (sponsorsinsightnoofsponresponse.error === 0) {
        }
      }
    );

    this.props.sponsorsinsightsponlistviewcount(
      this.props.session,
      (sponsorsinsightsponlistviewresponse) => {
        if (sponsorsinsightsponlistviewresponse.error === 0) {
        }
      }
    );

    this.props.sponsorsinsightsponprofviewcount(
      this.props.session,
      (sponsorsinsightsponprofviewresponse) => {
        if (sponsorsinsightsponprofviewresponse.error === 0) {
          //
        }
      }
    );

    // Call to Number of searches done on Sponsor list [Sponsor searches]
    this.props.sponsorsinsightsearchcount(
      this.props.session,
      (sponsorsinsightsearchcountResponse) => {
        if (sponsorsinsightsearchcountResponse.error === 0) {
          //
        }
      }
    );

    this.props.sponsorsinsightsponfavocount(
      this.props.session,
      (sponsorsinsightsponfavoresponse) => {
        if (sponsorsinsightsponfavoresponse.error === 0) {
          //
        }
      }
    );

    this.props.fetchSponsorsinsightMostsearkeysTableData(
      this.props.session,
      (sponsorsinsightmostsearkeysResponse) => {
        if (sponsorsinsightmostsearkeysResponse.error === 0) {
          //
        }
      }
    );

    // Top sponsors (sponsors profiles with most user engagement)
    this.props.fetchTopSponsorTableData(
      this.props.session,
      (fetchtopsponsortabledataResponse) => {
        if (fetchtopsponsortabledataResponse.error === 0) {
        }
      }
    );

    // Top sponsors ( engagement bar chart)
    this.props.fetchsponengagementbBarChart(
      this.props.session,
      this.props.datePropsMainPg,
      (fetchsponengagementbbarchartResponse) => {
        if (fetchsponengagementbbarchartResponse.error === 0) {
          this.setState({ loading: false });
        }
      }
    );
  };

  render() {
    let { deviceSize } = this.props;

    return (
      <div className="panel noborder-panel">
        {/* Header section */}
        {!this.state.loading ? (
          <AnalyticsCommonHeader
            finishOperationsCallback={this.mainCallback}
            callFrom="Sponsors Insights"
            xchart={this.newfc.bind(this)}
          />
        ) : (
          ""
        )}

        <div
          className="panel-body scrollable-content"
          style={{
            height: deviceSize.height - screenHeightLeftFromTop,
          }}
        >
          {this.state.loading ? (
            <div className="loader-container">
              {this.renderLoader()}
              <div className="loader-info">{this.state.desc}</div>
            </div>
          ) : (
            <div>
              <ul className="nav nav-pills dashboardNavPill">
                {this.renderSponsorinsightMenuIcons()}
              </ul>
              <div className="mt-20"></div>
              <div className="panel-body">
                {this.props.sopnbarchart ? (
                  <SponsorsinsightEngmntBarChart
                    sopnbarchart={this.props.sopnbarchart}
                    newprop={this.state.loader}
                  />
                ) : (
                  ""
                )}
                <TableContentTopSponsor />
                <TableContentMostsearchSponsorinsight />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  var { session, user, sponsorInsightMenu, sponsorsinsightSelectedItem } =
    state;

  var totalnoofspon = state.sponsorsinsightTotalNoofspon
    ? state.sponsorsinsightTotalNoofspon
    : [];
  var totalsponlistview = state.sponsorsinsightTotalSponlistview
    ? state.sponsorsinsightTotalSponlistview
    : [];
  var totalsponprofview = state.sponsorsinsightTotalSponprofview
    ? state.sponsorsinsightTotalSponprofview
    : [];
  var totalsponfavo = state.sponsorsinsightTotalSponfavo
    ? state.sponsorsinsightTotalSponfavo
    : [];
  var sponsmostsearkeys = state.sponsorsinsightMostsearkeysTablelist
    ? state.sponsorsinsightMostsearkeysTablelist
    : [];
  var topsponlist = state.sponsorsinsightTopsponTablelist
    ? state.sponsorsinsightTopsponTablelist
    : [];
  var sopnbarchart =
    state.sponsorsinsightengagementbarChart &&
    state.sponsorsinsightengagementbarChart.response &&
    state.sponsorsinsightengagementbarChart.response.length > 0
      ? state.sponsorsinsightengagementbarChart.response
      : [];
  var datePropsMainPg = state.analyticscommondatepropsreducer;
  //

  return {
    session,
    user,
    deviceSize: state.deviceSize,
    sponsorInsightMenu,
    sponsorsinsightSelectedItem,
    totalnoofspon,
    totalsponlistview,
    totalsponprofview,
    totalsponfavo,
    sponsmostsearkeys,
    topsponlist,
    sopnbarchart,
    datePropsMainPg,
  };
}

// Export with connect
export default connect(mapStateToProps, {
  sponsorsinsightnoofsponcount,
  sponsorsinsightsponlistviewcount,
  sponsorsinsightsponprofviewcount,
  sponsorsinsightsearchcount,
  sponsorsinsightsponfavocount,
  fetchSponsorsinsightMostsearkeysTableData,
  fetchTopSponsorTableData,
  fetchsponengagementbBarChart,
})(Sponsorsinsight);
